import { apiClient } from '@api';
import { useApplicationStore } from '@data';
import { PatientAccount, UtmParameters } from '@types';
import { AxiosResponse } from 'axios';

const telemetryConfig = {
  publicToken: import.meta.env.VITE_STYTCH_TOKEN,
  submitURL: 'auth-dfp.quick.md',
};

export async function verifyUniqueEmail(email: string): Promise<AxiosResponse> {
  const { leadSessionId } = useApplicationStore.getState();
  // @ts-expect-error GetTelemetryID is included in the stytch script
  const telemetryId = await GetTelemetryID(telemetryConfig);
  const data = await apiClient.post('/api/v2/auth/checkemailunique', {
    email,
    telemetryId,
    sessionId: leadSessionId,
  });

  return data;
}

interface RefreshAuthTokenParams {
  accessToken: string;
}

interface RefreshAuthTokenData {
  accessToken: string;
}

export async function refreshTokens({ accessToken }: RefreshAuthTokenParams) {
  const { data } = await apiClient.post<RefreshAuthTokenData>(
    '/api/v2/auth/refreshtoken',
    {
      accessToken,
    },
  );

  return data;
}

interface RegisterPatientParams extends PatientAccount {
  advertisingCampaign?: UtmParameters;
  isMarketingCommunicationAllowed: boolean;
  password: string;
  phoneNumberVerificationToken: string;
}

interface RegisterPatientData {
  accessToken: string;
  medicalRecordNumber: string;
  patientId: string;
  sessionId: string;
}

export async function registerPatient(
  params: RegisterPatientParams,
): Promise<RegisterPatientData> {
  // @ts-expect-error GetTelemetryID is included in the stytch script
  const telemetryId = await GetTelemetryID({
    publicToken: import.meta.env.VITE_STYTCH_TOKEN,
  });
  const { data } = await apiClient.post<RegisterPatientData>(
    '/api/v2/auth/register',
    { ...params, telemetryId },
  );

  return data;
}
